import http from './http'
export default{
    login(params){           //登陆
        return http.post('/login',params)
    },
    regist(params){           //机构注册
        return http.get('/account/org/regist',{params})
    },
    registExaminee(params){           //考生注册
        return http.get('/account/examinee/regist',{params})
    },
    forgetPwd(params){           //忘记密码
        return http.post('/account/forget/pwd',params)
    },
    examDetail(params){           //个人信息
        return http.get('/exam/detail',{params})
    },
    uploadImg(parmes){           // 上传图片
        return http.post(`/base/file/upload`,parmes)
    },
    examUpdate(parmes){           // 更新考生数据
        return http.post(`/exam/update`,parmes)
    },
    applyList(parmes){           // 获取报名列表
        return http.get(`/exam/apply/list?current=${parmes.current}&size=${parmes.size}`,'')
    },
    subjectsList(parmes){           // 获取科目列表
        return http.get(`/info/subjects/list`,{parmes})
    },
    subjectsLevelList(parmes){           // 获取科目等级列表
        return http.get(`/info/subjects_level/list?subjectsId=${parmes.subjectsId}`,'')
    },
    organizationList(parmes){           // 完全35小时培训机构
        return http.get(`/info/organization/list`,{parmes})
    },
    applySubmit(parmes){           // 报名提交
        return http.post(`/exam/apply/submit`,parmes)
    },
    orderList(parmes){           // 我的考试列表
        return http.get(`/exam/order/list?current=${parmes.current}&size=${parmes.size}`,'')
    },
    orderDetail(id){           // 我的考试列表
        return http.get(`/exam/order/detail?id=${id}`,'')
    },
    orderDelete(id){           // 删除考试
        return http.delete(`/exam/order/delete?id=${id}`,'')
    },
    delayedSubmit(parmes){           // 缓考提交
        return http.post(`/exam/delayed/submit/${parmes.code}`,parmes)
    },
    // 机构
    orgOrderList(parmes){           // 缓考提交
        return http.post(`/org/order/list`,parmes)
    },
    subjects(){           //科目列表
        return http.get(`/info/subjects/list`,'')
    },
    orgdetail(){           // 机构详情
        return http.get(`/org/detail`,'')
    },
    orgupdate(parmes){           // 提交机构详情
        return http.post(`/org/update`,parmes)
    },
    orgOrderAudit(params){           //科目列
        return http.get(`/org/order/audit?id=${params.id}&reason=${params.reason}&reject=${params.reject}`,'')
    },
    examOrderPay(parmes){           // 支付
        return http.post(`/exam/order/pay`,parmes)
    },
    infoImgBase64(img){           // 图片转换
        return http.get(`info/img/base64?path=${img}`,'')
    },
    infoComplaint(parmes){           // 举报
        return http.post(`/info/complaint`,parmes)
    },
    infoAllSeason(parmes){           // 考期列表
        return http.get(`/info/delayed/season`,'')
    },
    examOrderDelayed(id){           // 考期列表
        return http.get(`/exam/order/delayed?orderId=${id}`,'')
    },
    orgApplyAudit(){           //提交审核
        return http.get(`/org/apply/audit`,'')
    },
    accountSms(parmes){           //获取验证码
        return http.get(`/account/sms?phone=${parmes.phone}&type=${parmes.type}`,'')
    },

    //推荐信
    recommendList(){
        return http.get('/exam/recommend/all','');
    },
    recommendSave(parmes){
        return http.post('/exam/recommend/save',parmes)
    },
    recommendDel(id){
        return http.delete(`/exam/recommend/delete/${id}`,'')
    },
}


// WEBPACK FOOTER //
// ./src/api/api.js